import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useHistory, useLocation } from 'react-router-dom';
import { AlertIcon, BackArrowIcon } from '../../icon/icon';
import { MenuToggle } from '../../nav/menu.toggle';
import { ManagerNavigation } from '../../nav/manager.menu.navigation';
import { fetchNotificationComfirm } from '../../../api/alert';
import { LocationState } from '../../../interface/location.state';

const sidebarVariants = {
  open: {
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 40,
    },
  },
  closed: {
    x: '100%',
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 40,
    },
  },
};

interface ManagerHeaderProps {
  menuTitle: string;
  showBackArrow?: boolean;
}

const ManagerHeader = ({ menuTitle, showBackArrow }: ManagerHeaderProps) => {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const [alertState, setAlertState] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleAlertClick = () => {
    history.push('/common/alert');
  };

  const handleBackClick = () => {
    history.goBack();
  };

  useEffect(() => {
    const getNotificationComfirm = async () => {
      try {
        const response = await fetchNotificationComfirm();
        setAlertState(!response);
      } catch (error) {
        console.error(error);
      }
    };

    getNotificationComfirm();
  }, []);

  useEffect(() => {
    const getNotificationComfirm = async () => {
      try {
        const response = await fetchNotificationComfirm();
        setAlertState(!response);
      } catch (error) {
        console.error(error);
      }
    };

    // 경로가 '/common/alert'에 도착했을 때 호출
    if (location.pathname === '/common/alert') {
      getNotificationComfirm();
    }
  }, [location.pathname]); // 경로가 변경될 때마다 실행

  return (
    <HeaderContainer alertState={alertState}>
      <div className="title">
        {showBackArrow && (
          <div className="icon-box" onClick={handleBackClick}>
            <BackArrowIcon />
          </div>
        )}
        <SpanWrapper showBackArrow={showBackArrow}>{menuTitle}</SpanWrapper>
      </div>
      {!showBackArrow ? (
        <div className="subject">
          <div className="icon-box" onClick={handleAlertClick}>
            <AlertIcon />
          </div>
          <motion.nav initial={false} animate={isOpen ? 'open' : 'closed'}>
            <MenuToggle toggle={() => setIsOpen(!isOpen)} />
            <motion.div
              variants={sidebarVariants}
              style={{
                backgroundColor: '#FFF',
                position: 'fixed',
                width: '100%',
                height: '100%',
                zIndex: 100,
                top: 0,
                left: 0,
              }}
            >
              {isOpen && <ManagerNavigation setIsOpen={setIsOpen} />}
            </motion.div>
          </motion.nav>
        </div>
      ) : null}
    </HeaderContainer>
  );
};

export default ManagerHeader;

//style
const HeaderContainer = styled.header<{ alertState: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 1.1rem 1.4rem;
  .title {
    font-size: 2.2rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 1.2rem;
    color: ${(props) => props.theme.textBlackColor};
    .icon-box {
      display: flex;
    }
    span {
      transform: translateY(1px);
    }
  }
  .subject {
    display: flex;
    align-items: center;
  }
  nav {
    width: 3.2rem;
    height: 3.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.8rem 0.7rem;
    span {
      display: flex;
      width: 1.8rem;
      height: 2rem;
      background-color: ${(props) => props.theme.menuNavColor};
    }
  }
  .icon-box {
    display: flex;
    svg {
      .nev-alert {
        fill: ${(props) => (props.alertState ? '#FF5151' : 'transparent')};
      }
    }
  }
`;

const SpanWrapper = styled.span<{ showBackArrow?: boolean }>`
  ${({ showBackArrow }) =>
    showBackArrow &&
    `
    font-size: 1.6rem;
    font-weight: 600;
    position: absolute;
    top: 1.9rem;
    left: 50%;
    transform: translateX(-50%) !important;
  `}
`;
